export default __webpack_public_path__ + "static/media/fasting_16_8@2x.ac973731.jpg";